
import Vue from 'vue';
import gql from 'graphql-tag';
import DeviceReportPieChart from './DeviceReportPieChart.vue';
import DeviceReportBarChart from './DeviceReportBarChart.vue';
import { normalizeDateRange } from '~shared/utils';

export default Vue.extend({
  components: {
    DeviceReportPieChart,
    DeviceReportBarChart,
  },
  props: {
    includeArchivedCampaigns: {
      type: Boolean,
      default: false,
    },
    isNoData: {
      type: Boolean,
      default: false,
    },
  },
  data(): any {
    return {
      startDate: '',
      endDate: '',
      stats: [],
      fields: [
        {
          key: 'device',
          label: 'Device',
          tdClass: 'text-capitalize',
          formatter(item) {
            return item.toLowerCase();
          },
        },
        {
          key: 'impressions',
          label: 'Impressions',
          sortable: true,
        },
        {
          key: 'clicks',
          label: 'Clicks',
          sortable: true,
        },
        {
          key: 'ctr',
          label: 'CTR',
          sortable: true,
          formatter(item) {
            return `${item.toFixed(2)}%`;
          },
        },
      ],
      loading: false,
    };
  },
  computed: {
    campaignId(): string | null {
      const selectedCampaign =
        this.$store.state['advertiser-insights'].filters.selectedCampaign;
      if (!selectedCampaign || !selectedCampaign.id) {
        return null;
      }
      return selectedCampaign.id;
    },
    groupId(): string | null {
      const selectedGroup =
        this.$store.state['advertiser-insights'].filters.selectedGroup;
      if (!selectedGroup || !selectedGroup.id) {
        return null;
      }
      return selectedGroup.id;
    },
    selectedDateRange(): Date[] {
      return this.$store.state['advertiser-insights'].filters.selectedDateRange;
    },
  },
  watch: {
    selectedDateRange: {
      handler(val): void {
        if (val.length === 2) {
          const { startDate, endDate } = normalizeDateRange({
            startDate: val[0],
            endDate: val[1],
          });

          this.startDate = startDate.toISOString();
          this.endDate = endDate.toISOString();
        }
      },
      deep: true,
      immediate: true,
    },
    stats: {
      handler(val): void {
        this.$emit('update:isNoData', this.loading || !val.length);
      },
      deep: true,
      immediate: true,
    },
    loading: {
      handler(val): void {
        this.$emit('update:isNoData', val || !this.stats.length);
      },
      deep: true,
      immediate: true,
    },
  },
  apollo: {
    stats: {
      query: gql`
        query (
          $groupIds: [ID!]
          $campaignId: ID!
          $startDate: DateTime!
          $endDate: DateTime!
          $includeArchivedCampaigns: Boolean
        ) {
          CampaignDeviceStatistics(
            groupIds: $groupIds
            campaignId: $campaignId
            startDate: $startDate
            endDate: $endDate
            includeArchivedCampaigns: $includeArchivedCampaigns
          ) {
            statistics {
              clicks
              impressions
              ctr
              device
            }
          }
        }
      `,
      watchLoading(isLoading) {
        this.loading = isLoading;
      },
      variables(): any {
        const campaignId = this.campaignId || '';
        const groupIds = [this.groupId];
        return {
          groupIds,
          campaignId,
          startDate: this.startDate,
          endDate: this.endDate,
          includeArchivedCampaigns: this.includeArchivedCampaigns,
        };
      },
      skip(): boolean {
        return !this.groupId || !this.startDate || !this.endDate;
      },
      notifyOnNetworkStatusChange: true,
      debounce: 200,
      update(data): [] {
        if (data.CampaignDeviceStatistics) {
          return data.CampaignDeviceStatistics.statistics;
        }
        return [];
      },
    },
  },
});
